import React from "react";
import { useLocation } from "react-router-dom";
import { FullPageSpinner } from "components/Spinner";
import { useSessionCtx } from "utils";

export const ThreeDS2Callback = () => {
  const { debug } = useSessionCtx();
  const location = useLocation();
  debug("ThreeDS2Callback__location: ", location);
  return <FullPageSpinner />;
};
